module monitoringApp.controllers {
 
    class LoginController {
        
        constructor() {
            console.log("loginctrl");
        }
        static $inject = [];
    }

    angular.module("ultimateMonitoringApp").controller("loginController", LoginController);
            
}
